<div class="atn-ds-date-range-overlay-content-custom-ranges">
  @for (range of customRanges; track $index) {
    <div
      class="atn-ds-date-range-overlay-content-custom-ranges__item"
      (click)="predefinedRangeClickHandler(range)"
    >
      {{ range }}
    </div>
  }
</div>
